import { NodeViewContent, NodeViewWrapper, type ReactNodeViewProps, useEditorState } from "@tiptap/react";
import { appendGroupItem, insertGroupAfter, removeGroup } from "../structure";

export function GroupView({ node, editor, getPos, updateAttributes }: ReactNodeViewProps) {
  const editable = useEditorState({ editor, selector: ({ editor: e }) => e.isEditable });
  const title = String(node.attrs.title ?? "");
  const meta = (node.attrs.meta as string | null) ?? null;
  const at = (fn: (pos: number) => void) => () => {
    const pos = getPos();
    if (typeof pos === "number") fn(pos);
  };
  const update = (attrs: Record<string, unknown>) => {
    if (editor.isEditable) updateAttributes(attrs);
  };
  return (
    <NodeViewWrapper className="kd-group">
      <div className="kd-group__head" contentEditable={false}>
        {editable ? (
          <>
            <input
              className="kd-group__title-input"
              aria-label="Group title"
              placeholder="Group title"
              value={title}
              onChange={(e) => update({ title: e.target.value })}
            />
            <input
              className="kd-group__meta-input"
              aria-label="Group meta line"
              placeholder="Meta line (optional)"
              value={meta ?? ""}
              onChange={(e) => update({ meta: e.target.value === "" ? null : e.target.value })}
            />
            <button
              type="button"
              className="kd-tool kd-tool--on-dark"
              aria-label="Add item"
              onClick={at((p) => appendGroupItem(editor, p))}
            >
              + Item
            </button>
            <button
              type="button"
              className="kd-tool kd-tool--on-dark"
              aria-label="Add group"
              onClick={at((p) => insertGroupAfter(editor, p))}
            >
              + Group
            </button>
            <button
              type="button"
              className="kd-tool kd-tool--on-dark"
              aria-label="Remove group"
              title="Remove this group (a group list keeps at least one)"
              onClick={at((p) => removeGroup(editor, p))}
            >
              Remove
            </button>
          </>
        ) : (
          <>
            <span className="kd-group__title">{title}</span>
            {meta ? <span className="kd-group__meta">{`   |   ${meta}`}</span> : null}
          </>
        )}
      </div>
      <NodeViewContent className="kd-group__items" />
    </NodeViewWrapper>
  );
}
